var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPolygonDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8L-2.54292e-07 7.94465e-08L10 9.53674e-07L5 8Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolygonDown);
export default __webpack_public_path__ + "static/media/icon_polygon_down.ca8bbf6305018265f054ed3d47e029a1.svg";
export { ForwardRef as ReactComponent };